// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__8fk8X","titleContainer":"styles_titleContainer__3lH1t","title":"styles_title__h7GcP","value":"styles_value__AqRQt"};